import { useState, useEffect } from 'react';

interface AnimatedCounterProps {
  value: number;
  suffix?: string;
  isVisible: boolean;
  duration?: number;
}

export default function AnimatedCounter({
  value,
  suffix = '',
  isVisible,
  duration = 2000,
}: AnimatedCounterProps) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible || value <= 0) return;

    let start = 0;
    const increment = value / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, value, duration]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
}
